import { useEffect } from 'react';

import SmartImageLib from 'Lib/SmartImageLib';

type Options = {
  shouldLazyLoad?: boolean;
  inViewport?: boolean;
  loaded?: boolean;
  urls: string[];
};

const useDownloadImages = (imageLib: SmartImageLib, options: Options) => {
  const { shouldLazyLoad, urls, inViewport, loaded } = options;
  useEffect(() => {
    if (loaded) {
      return;
    }

    if (!shouldLazyLoad) {
      imageLib.downloadImages(urls);
      return;
    }

    if (inViewport) {
      imageLib.downloadImages(urls);
    }
  }, [shouldLazyLoad, imageLib, inViewport, urls, loaded]);
};

export default useDownloadImages;
